// extracted by mini-css-extract-plugin
export default {"input":"PaySumCell_input__M9iNw","cell":"PaySumCell_cell__D5MXq"};